module.exports = __webpack_public_path__ + "static/media/ips-alias.df3e78ca.svg";